import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useReorderFreeTierMutation = createMutationHook(
  MembershipsCreatorApiClient.reorderFreeTier,
  {
    mutationKey: ['reorderFreeTier'],
  },
)
